import { Table, Button, Form, DatePicker, Select, Checkbox } from "antd";
import React, { useState, useEffect } from "react";

import arrowDown from "../../../assets/icons/arrow-down12.png";
import calendar from "../../../assets/icons/calendar.png";
import plus from "../../../assets/icons/add-circle2.png";
import trash from "../../../assets/icons/trash2.png";

import { patientHistoryprocedures } from "../testData";

export default function AudiencePatientHistoryFilter({
  setPatientHistoryFilter,
  patientHistoryFilter,
  createdPatientHistories,
  setCreatedPatientHistories,
  newPatientHistory,
  setNewPatientHistory,
}) {
  const [showForm, setShowForm] = useState(true);
  const [checked, setChecked] = useState(false);
  const [allFieldsFill, setAllFieldsFIll] = useState(false);
  const [isArrowDown, setIsArrowDown] = useState(true);

  const patientHistoryTableColumns = [
    {
      title: "Procedure Code",
      dataIndex: "procedure_code",
      key: "procedure_code",
      width: 192,
      render: (text, record, index) => {
        if (showForm && index === createdPatientHistories.length) {
          return (
            <Form.Item name="procedure_code" rules={[{ required: true, message: "Required" }]} style={{ margin: 0 }}>
              <Select
                options={patientHistoryprocedures}
                placeholder="Select Procedure"
                className="custom-style-selection-insurance-filter"
                style={{ width: "100%", display: "flex", alignItems: "center" }}
                value={newPatientHistory.procedure_code}
                suffixIcon={<img style={{ width: 18, transform: `rotate(${isArrowDown ? "0" : "180deg"})` }} src={arrowDown} alt="arrow-down" />}
                onOpenChange={() => setIsArrowDown((down) => !down)}
                onChange={(value) => setNewPatientHistory((prevData) => ({ ...prevData, procedure_code: value }))}
              />
            </Form.Item>
          );
        }
        return text;
      },
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      width: 251,
      render: (text, record, index) => {
        if (showForm && index === createdPatientHistories.length) {
          return (
            <Form.Item name="start_date" rules={[{ required: true, message: "Required" }]} style={{ margin: 0 }}>
              <DatePicker
                suffixIcon={<img src={calendar} alt="calendar" />}
                format="YYYY-MM-DD"
                dateFormat="YYYY-MM-DD"
                className="audience-filters-date-input"
                onChange={(value) =>
                  setNewPatientHistory((prevData) => ({
                    ...prevData,
                    start_date: value ? value.format("YYYY-MM-DD") : "",
                  }))
                }
              />
            </Form.Item>
          );
        }
        return text;
      },
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      render: (text, record, index) => {
        if (showForm && index === createdPatientHistories.length) {
          return (
            <Form.Item name="end_date" style={{ margin: 0 }}>
              <DatePicker
                suffixIcon={<img src={calendar} alt="calendar" />}
                format="YYYY-MM-DD"
                dateFormat="YYYY-MM-DD"
                className="audience-filters-date-input"
                onChange={(value) =>
                  setNewPatientHistory((prevData) => ({
                    ...prevData,
                    end_date: value ? value.format("YYYY-MM-DD") : "",
                  }))
                }
              />
            </Form.Item>
          );
        }
        return text;
      },
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (text, record, index) => {
        return (
          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            {showForm && index === createdPatientHistories.length ? (
              <Checkbox checked={checked} disabled={!allFieldsFill} onChange={() => setChecked((prev) => !prev)} className="custom-action-checkbox" />
            ) : (
              <img
                src={trash}
                alt="trash"
                style={{ cursor: "pointer" }}
                onClick={() => setCreatedPatientHistories((prevFilters) => prevFilters.filter((prevFilter) => prevFilter.key !== record.key))}
              />
            )}
          </div>
        );
      },
    },
  ];

  // Enable checkbox only when all fields are filled
  useEffect(() => {
    const filled = newPatientHistory.procedure_code && newPatientHistory.start_date && newPatientHistory.end_date;
    setAllFieldsFIll(!!filled);
  }, [newPatientHistory]);

  // When checkbox is checked, add the filter and reset
  useEffect(() => {
    if (checked && allFieldsFill) {
      setCreatedPatientHistories((prev) => [...prev, { ...newPatientHistory }]);
      setPatientHistoryFilter((prev) => [
        ...prev,
        {
          integer_value: newPatientHistory.procedure_code,
          date_range: {
            lower: newPatientHistory.start_date,
            upper: newPatientHistory.end_date,
          },
        },
      ]);
      setNewPatientHistory({ procedure_code: "", start_date: "", end_date: "" });
      setChecked(false);
      setShowForm(false);
    }
  }, [checked]);

  // Show the form if all filters get removed
  useEffect(() => {
    if (createdPatientHistories.length === 0) {
      setShowForm(true);
    }
  }, [createdPatientHistories]);

  // Compose table data
  const tableData = showForm ? [...createdPatientHistories, { key: "form-row" }] : createdPatientHistories;

  return (
    <div>
      <Table columns={patientHistoryTableColumns} dataSource={tableData} rowKey={(record, index) => index} pagination={false} />

      <Button
        style={{
          width: "100%",
          borderRadius: "0 0 10px 10px",
          padding: "20px 0",
          color: "#6B43B5",
          border: "1px solid #6b43B5",
        }}
        onClick={() => setShowForm(true)}
        disabled={showForm && !allFieldsFill}
      >
        {showForm && allFieldsFill ? (
          "Save"
        ) : (
          <>
            Add Another Procedure <img src={plus} alt="add" />
          </>
        )}
      </Button>
    </div>
  );
}
